import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ContactList = () => {
  const [ContactUser, setContactUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correct API (GET)
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_contact_us"
        );

        if (response.data.success === "1") {
          setContactUser(response.data.data);
        } else {
          toast.error("Failed to fetch Conatct");
        }
      } catch (error) {
        console.error(error);
        toast.error("API Error");
      }
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
  try {
    console.log("Deleting Contact ID:", userId);

    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_contact_us",
      {
        id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Delete response:", response.data);

    if (response.data.success === "1" || response.data.status === true) {
      setContactUser((prev) =>
        prev.filter((user) => user.id !== userId)
      );
      toast.error(response.data.message || "Contact deleted successfully");
    } else {
      toast.error(response.data.message || "Delete failed");
    }
  } catch (error) {
    console.error("Delete error", error);
    toast.error("Failed to delete Contact.");
  }
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Conatct List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Conatct</Link>
                </li>
                <li className="breadcrumb-item active">Conatct List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Contact Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title flex-grow-1">All Conatct List</h4>
              </div>

              <div className="table-responsive">
                <table className="table align-middle mb-0 table-hover table-centered">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>E-mail</th>
                      <th>Date</th>
                      <th>Message</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {ContactUser.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input type="checkbox" className="form-check-input" />
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-2">
                            {/* <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                              <img
                                src={
                                  item.image
                                    ? `https://cyberathon.com/multivendor/${item.image}`
                                    : "/images/no-image.png"
                                }
                                alt="Contact"
                                className="avatar-md"
                              />
                            </div> */}

                            <p className="text-dark fw-medium fs-15 mb-0">
                              {item.name}
                            </p>
                          </div>
                        </td>

                        <td>{item.email}</td>

                        <td>{item.created_at}</td>

                        <td>{item.massage}</td>

                        <td>
                          <div className="d-flex gap-2">
                            <span
                              onClick={() => deleteUser(item.id)}
                              className="btn btn-soft-danger btn-sm"
                            >
                              <i className="fa-solid fa-trash fs-18"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination (Not changed) */}
              <div className="card-footer border-top">
                <nav>
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <Link className="page-link">Previous</Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link">1</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">2</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">3</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">Next</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 text-center">
                    © Venton. Crafted by{" "}
                    <iconify-icon
                      icon="iconamoon:heart-duotone"
                      className="fs-18 align-middle text-danger"
                    />{" "}
                    <Link to="#" className="fw-bold footer-text" target="_blank">
                      Techzaa
                    </Link>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default ContactList;